import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { ConfigLoader } from './app/config-loader';

// Load config before bootstrapping Angular
ConfigLoader.loadConfig()
  .then(() => {
    const config = ConfigLoader.getConfig();
    Sentry.init({
      dsn: 'https://a47cf68ae7fc7064d1844d231ba975b1@o4508617940074496.ingest.de.sentry.io/4510923252367440',
      environment: config.environment ?? 'unknown',
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true
    });

    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  })
  .catch((err) => {
    console.error('Failed to load config, bootstrapping with defaults:', err);
    bootstrapApplication(AppComponent, appConfig).catch((bootstrapErr) => console.error(bootstrapErr));
  });
